import { Unity } from "./unity";
import { Driver } from "./driver";
import { User } from "./user";
import { TravelLine } from "./travel-line";
import { Expense } from "./expense";
import { TravelExpense } from "./travel-expense";
import { GasTravel } from "./gas-travel";
import { SaleOrderWm } from "./sale-order-wm";
import { CommercialDocument } from './commercial-document';

export class Travel {
    id: number = 0;
    unity_id: number = 0;
    unity: Unity = new Unity();
    trailer_1_id: number = 0;
    trailer_1: Unity = new Unity();
    trailer_2_id: number = 0;
    trailer_2: Unity = new Unity();
    trailer_3_id: number = 0;
    trailer_3: Unity = new Unity();
    operator_id: number = 0;
    operator: Driver = new Driver();
    helper_1_id: number = 0;
    helper_1: Driver = new Driver();
    helper_2_id: number = 0;
    helper_2: Driver = new Driver();
    description: string;
    delivery_date: Date = new Date();
    gas_loading_date: Date = new Date();
    prd_loading_date: Date = new Date();
    user_id: number = 0;
    set_id: number = 0;
    user: User = new User();
    departure_date: Date = new Date();
    arrival_date: Date = new Date();
    gas_total: number = 0;
    gas_ticket: number = 0;
    gas_ticket_2: number = 0;    
    ton_total: number = 0;
    ton_real_total: number = 0;
    meters_total: number = 0;
    time_total: number = 0;
    status: string = '';
    paysheet_date:any = '';
    paysheet_type:string = '';
    paysheet_base:number = 0;
    unit_type_presentation: string = 'Sencillo';
    lines: TravelLine[] = [];
    expenses:TravelExpense[] = [];
    operator_cost: number = 0;
    helper_1_cost: number = 0;
    helper_2_cost: number = 0;
    contracted:boolean = true;
    
    newticket: boolean = true;
    gas_metric_initial: number = 0;
    gas_metric_final: number = 0;
    gas_real: number = 0;
    gas_date_proeco: any = 0;
    gas_description_proeco: number = 0;
    gas_metric_initial_2: number = 0;
    gas_metric_final_2: number = 0;
    gas_real_2: number = 0;
    gas_date_proeco_2: any = 0;
    gas_description_proeco_2: number = 0;
    interplanta: boolean = false;

    paysheet_in_cash_operator:boolean = true;
    paysheet_in_cash_helper_1:boolean = true;
    paysheet_in_cash_helper_2:boolean = true;

    gas_travel:GasTravel[] = null;
    canUnlimitedLoad : boolean = false;

    sale_order_id : number = 0;
    sale_order : SaleOrderWm;

    invoice:string = "";

    user_calculates_paysheet_expenses_id: number = null;
    userCalculatesPaysheetExpenses: User = new User();
    datetime_calculates_paysheet_expenses: any;
}
